module.exports = __webpack_public_path__ + "img/switch-blue.e443ec84.svg";